import _get from 'lodash/get';
import { Values, Option } from '@lib/interfaces/form';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import getMonitoringEntity from './getMonitoringEntity';
import getFilterFieldNameByMonitoringEntity from './getFilterFieldNameByMonitoringEntity';
import { StatusKind } from '../enums';

export default function getStatusKind({
  filterParams,
}: {
  filterParams: Values;
}) {
  const monitoringEntity = getMonitoringEntity({ filterParams });
  const statusOption = _get(
    filterParams,
    getFilterFieldNameByMonitoringEntity(
      monitoringEntity,
      MonitoringFilterFieldNames.Status,
    ),
    [],
  ) as Option[];
  const statusKind = _get(statusOption, 'value') as StatusKind | undefined;
  return statusKind;
}
